import React, { useEffect, useState } from 'react';
import './admin-users.styles.scss';
import SearchBar from '../../SHARED/search-bar/search-bar.component';
import { UseCloudAdminFunction } from '../../../utils/firebase.utils';
import { useSelector } from 'react-redux';
import ThreeDotsLoader from '../../SHARED/loader/three-dots-loader.component';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import UserView from './user-view.component';

const AdminUsers = () => {

  const screenSize = useSelector(state => state.listsData.screenSize);
  const userProfile = useSelector(state => state.userData.userProfile);
  const [ resultsToDisplay, setResultsToDisplay ] = useState(null);
  const [ loading, setLoading ] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!userProfile) return;
    const inputElement = document.getElementById('user-search');
    if (!inputElement) return;
    inputElement.addEventListener('keyup', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();             
        search();
      }
    });
  }, [userProfile])

  async function search() {
    setLoading(true);
    setResultsToDisplay(null);
    const input = document.getElementById('user-search').value.toLowerCase();
    const inputArr = input.split(' ')
          .map(i => i.trim())
          .filter(i => i !== '')
    console.log(inputArr);
    // return;
    const res = await UseCloudAdminFunction(
      'searchForUsersInNfe',
      {
        'searchTextArr': inputArr,
        'cstKey': userProfile.id
      }
    )
    console.log(res);
    // sort results by last name, then by first name if the all are the same
    const sortedResults = res.sort((a, b) => {
      if (a.ind_last_name === b.ind_last_name) {
        return a.ind_first_name.localeCompare(b.ind_first_name);
      }
      return a.ind_last_name.localeCompare(b.ind_last_name);
    });
    const uniqueArray = [];
    const seenKeys = new Set();

    for (const item of sortedResults) {
      if (!seenKeys.has(item.ind_cst_key)) {
        uniqueArray.push(item);
        seenKeys.add(item.ind_cst_key);
      }
    }
    setResultsToDisplay(uniqueArray);
    setLoading(false);
  }

  return (
    <div className={`admin-users-container ${screenSize}`}>
      <div className='admin-users-card g-card'>
        <h3>Manage Users</h3>
        <hr />
        <Routes>
          <Route path='' element={
            <div className='admin-users-search'>
              <SearchBar search={() => {}} idLabel="user-search" />
              <div className="g-space-1"></div>
              <div className='buttons'>
                {
                  (loading)
                  ?
                  <button className='g-button med-btn'>
                    <ThreeDotsLoader />
                  </button>
                  :
                  <button 
                    className='g-button med-btn' 
                    onClick={() => search()}>
                    Search
                  </button>
                }
              </div>
              <div className="g-space-1"></div>
              {
                (
                  (resultsToDisplay) &&
                  (screenSize === 'mobile' || screenSize === 'tablet')
                )
                ?
                <div className='mobile-user-list'></div>
                :
                (resultsToDisplay) &&
                <table className='uk-table uk-table-striped'>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Email</th>
                      <th>School</th>
                      <th>District</th>
                      <th>Role</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      (resultsToDisplay && resultsToDisplay.length > 0) 
                      ? 
                        resultsToDisplay.map(user => (
                          <tr key={user.ind_cst_key}>
                            <td>{user.ind_last_name}, {user.ind_first_name}</td>
                            <td title={user.cst_eml_address_dn}>
                              {
                                user.cst_eml_address_dn 
                                ? user.cst_eml_address_dn.substring(0, 20) + 
                                  (user.cst_eml_address_dn.length > 20 ? '...' : '')
                                : 'N/A'
                              }</td>
                            <td title={user.cst_org_name_dn}>
                              {
                                user.cst_org_name_dn 
                                ? user.cst_org_name_dn.substring(0, 20) + 
                                  (user.cst_org_name_dn.length > 20 ? '...' : '')
                                : 'N/A'
                              }</td>
                            <td title={user.v01_ultimate_org_name}>
                              {
                                user.v01_ultimate_org_name
                                ? user.v01_ultimate_org_name.substring(0, 20) + 
                                  (user.v01_ultimate_org_name.length > 20 ? '...' : '')
                                : 'N/A'
                              }
                            </td>
                            <td title={user.cst_ixo_title_dn}>
                              {
                                user.cst_ixo_title_dn
                                ? user.cst_ixo_title_dn.substring(0, 10) + 
                                  (user.cst_ixo_title_dn.length > 10 ? '...' : '')
                                : 'N/A'
                              }
                            </td>
                            <td className='buttons'>
                              <button
                                className='g-button small-btn'
                                onClick={() => navigate(`/admin/users/${user.ind_cst_key}`)}>
                                  <FontAwesomeIcon icon={faMagnifyingGlass} />
                              </button>
                            </td>
                          </tr>
                        ))
                      : 
                        (resultsToDisplay && resultsToDisplay.length === 0) &&
                        <tr>
                          <td colSpan="6">No results found</td>
                        </tr>
                    }
                  </tbody>
                </table>
              }
            </div>
          }></Route>
          <Route path=':cstKey' element={
            <UserView />
          }></Route>
        </Routes>
      </div>
    </div>
  )
}

export default AdminUsers